import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'

export const theme = createTheme({
    // palette: {
    //     primary: {
    //         // main: '#1589ad' // biru
    //         // main: '#164858' // agak kehitaman
    //     },
    //     secondary: {
    //         // main: '#f98d2b',
    //         // main: '#f38726', // alittle bit darker (our previous orange - default)
    //         // main: '#f97e0f',  // alittle more darker
    //         main: '#9d8168', // coklat
    //         contrastText: 'white'
    //     }
    // },
    typography: {
        // fontFamily: "'IBM Plex Sans', sans-serif",
        h1: {
            fontSize: 26
        },
        h2: {
            fontSize: 24
        },
        h3: {
            fontSize: 22
        },
        h4: {
            fontSize: 20
        },
        h5: {
            fontSize: 18
        },
        h6: {
            fontSize: 16
        },
        body1: {
            fontSize: 16,
            '@media (max-width:500px)': {
                fontSize: 14
            }
        },
        body2: {
            fontSize: 14,
            '@media (max-width:500px)': {
                fontSize: 12
            }
        }
    }
})

export default function OurTheme(props) {
    return (
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    )
}

// export default ourTheme
